import axiosLib, { AxiosRequestConfig, isAxiosError } from "axios";
import storage from "./storage";
import { API_URL } from "./config";

export const api = axiosLib.create({
	baseURL: API_URL,
	headers: {
		"Content-Type": "application/json",
		accept: "application/json",
	},
});

api.interceptors.request.use(
	(config: any) => {
		const accessToken = storage.getItem("accessToken");

		if (accessToken) {
			config.headers.Authorization = `Bearer ${accessToken}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

api.interceptors.response.use(
	(response: any) => {
		return response;
	},
	async (error) => {
		if (!isAxiosError(error)) {
			return Promise.reject(error);
		}

		// Reject when the response is not 401
		if (error.response?.status !== 401) {
			return Promise.reject(error);
		}
		if (
			error.response?.status === 401 &&
			error.response.data.message === "jwt expired"
		) {
			storage.removeItem("accessToken");
			storage.removeItem("refreshToken");
			storage.removeItem("accessStatus");
			window.location.href = "/login";
			return Promise.reject(error);
		}
		if (error.response?.status === 401) {
			// Reject when the response is 401 but tried to /auth/refresh
			return Promise.reject(error);
		}

		// if (
		// 	error.response?.status === 401 &&
		// 	(error.response.config.url?.endsWith("/auth/refresh") ||
		// 		error.response.config.url?.endsWith("/auth/change-password"))
		// ) {
		// 	// Reject when the response is 401 but tried to /auth/refresh
		// 	return Promise.reject(error);
		// }

		const originalRequest = error.config;
		if (!originalRequest) {
			return Promise.reject(error);
		}

		// let newAccessToken: string | undefined = undefined;
		// try {
		// 	const refreshToken = storage.getItem("refreshToken");
		// 	const response = await api.post(`${API_URL}/auth/refresh`, {
		// 		refreshToken,
		// 	});
		// 	newAccessToken = response.data.accessToken;
		// } catch (err) {
		// 	return Promise.reject(error);
		// }

		// Reject when there is no new access token
		// if (!newAccessToken) {
		// 	return Promise.reject(error);
		// }

		// Retry using the new access token
		// storage.setItem("accessToken", newAccessToken);
		// originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
		return api(originalRequest);
	}
);

const ApiCalls = {
	get: async (url: string, options?: AxiosRequestConfig) => {
		try {
			return await api.get(url, options);
		} catch (error: any) {
			error.request = { url, options };
			throw error;
		}
	},
	delete: async (url: string, options?: AxiosRequestConfig) => {
		try {
			return await api.delete(url, options);
		} catch (error: any) {
			error.request = { url, options };
			throw error;
		}
	},
	post: async (url: string, data: any = {}, options?: AxiosRequestConfig) => {
		try {
			return await api.post(url, data, options);
		} catch (error: any) {
			error.request = { url, data, options };
			throw error;
		}
	},
	put: async (url: string, data: any, options?: AxiosRequestConfig) => {
		try {
			return await api.put(url, data, options);
		} catch (error: any) {
			error.request = { url, data, options };
			throw error;
		}
	},
	patch: async (url: string, data: any, options?: AxiosRequestConfig) => {
		try {
			return await api.patch(url, data, options);
		} catch (error: any) {
			error.request = { url, data, options };
			throw error;
		}
	},
};

export default ApiCalls;
